// eslint-disable-next-line no-unused-vars
import React from 'react';

import { logger } from '@lusha/client-logger';
import { PLATFORM } from '@lusha/source-platforms';
import { reportClientEvent } from '@lusha-growth/bi-client-sdk';

import { useMST } from './MSTHook';

const useReportClientEvent = (sharedProps = {}) => {
  const { userSettings, context } = useMST(store => ({ userSettings: store.userSettings, context: store.context }));

  function getPageUrl() {
    if (context.url) {
      return context.url;
    }
    const url = (window.location !== window.parent.location) ? document.referrer : document.location.href;
    logger.warn('[Plugin - report client event] Page url is not available. Using document.location.href. Context:', context);

    return url;
  }

  const defaultProps = ({
    platform: PLATFORM.PLUGIN,
    subPlatform: userSettings.platform,
    pageUrl: getPageUrl(),
  });

  return props => reportClientEvent({
    teamName: sharedProps?.teamName || 'plugin',
    isLoggedIn: true,
    metadata: {
      ...defaultProps,
      ...sharedProps,
      ...props,
    },
  });
};

export default useReportClientEvent;
